module.exports = __webpack_public_path__ + "static/media/androidIcon.8531be07.svg";